const deleteSpacesFromString = (value) => {
  return value.replace(/\s/g, "");
};

export default deleteSpacesFromString;
